<ppl-top-bar #topBar>
  <!-- <ppl-top-navigation enableHelp="true" enableUserMenu="true"></ppl-top-navigation> -->
</ppl-top-bar>

<ppl-not-found [errorImageUrl]="errorImageUrl"></ppl-not-found>
